import { Fragment } from "react";

// Renderiza una cadena con marcadores mínimos de estilo:
//   **texto**  ->  <strong>   *texto*  ->  <em>
// Pensado para resaltar palabras clave dentro de párrafos y bullets del CV
// sin depender de una librería de markdown ni de HTML sin sanear.
const TOKEN = /\*\*([^*]+)\*\*|\*([^*]+)\*/g;

export default function RichText({ text }) {
  if (!text) return null;
  const nodes = [];
  let lastIndex = 0;
  let key = 0;
  let match;

  while ((match = TOKEN.exec(text)) !== null) {
    if (match.index > lastIndex) {
      nodes.push(<Fragment key={key++}>{text.slice(lastIndex, match.index)}</Fragment>);
    }
    if (match[1] != null) {
      nodes.push(<strong key={key++}>{match[1]}</strong>);
    } else {
      nodes.push(<em key={key++}>{match[2]}</em>);
    }
    lastIndex = TOKEN.lastIndex;
  }
  if (lastIndex < text.length) {
    nodes.push(<Fragment key={key++}>{text.slice(lastIndex)}</Fragment>);
  }
  return <>{nodes}</>;
}
